type LabsOrderStep = 1 | 2 | 3 | 4 | 5;

interface LabsOrderHeaderProps {
  currentStep: LabsOrderStep;
  onBack?: () => void;
  onClose?: () => void;
  showBackButton?: boolean;
}

const TOTAL_STEPS = 5;

export function LabsOrderHeader({
  currentStep,
  onBack,
  onClose,
  showBackButton = true
}: LabsOrderHeaderProps) {
  return (
    <div className="mb-8">
      {/* Navigation Row: Back | Step | Close */}
      <div className="mb-6 flex items-center justify-between">
        {showBackButton && onBack ? (
          <button
            onClick={onBack}
            className="flex items-center text-gray-900 transition-colors hover:text-gray-600"
            aria-label="Go back"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        ) : (
          <div className="w-6" />
        )}

        {/* Step Indicator */}
        <span className="text-lg font-medium text-gray-900">
          {currentStep}/{TOTAL_STEPS}
        </span>

        {onClose ? (
          <button
            onClick={onClose}
            className="flex items-center text-gray-900 transition-colors hover:text-gray-600"
            aria-label="Close order flow"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        ) : (
          <div className="w-6" />
        )}
      </div>

      {/* Segmented Progress Bar */}
      <div className="flex gap-2">
        {Array.from({ length: TOTAL_STEPS }, (_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          const isLastStep = currentStep === TOTAL_STEPS;

          // Last step shows full green, other current steps show half green
          if (isCurrent) {
            return (
              <div key={stepNumber} className="relative h-1 flex-1 overflow-hidden rounded-full bg-gray-200">
                <div
                  className="h-full rounded-full bg-[#70E4C8] transition-all duration-300 ease-out"
                  style={{ width: isLastStep ? '100%' : '50%' }}
                />
              </div>
            );
          }

          return (
            <div
              key={stepNumber}
              className={`h-1 flex-1 rounded-full transition-colors duration-300 ease-out ${
                isCompleted ? 'bg-[#70E4C8]' : 'bg-gray-200'
              }`}
            />
          );
        })}
      </div>
    </div>
  );
}
